export const DECORATIVE_IMAGE_ALT = ''
export const DEFAULT_TAB_INDEX = 0
export const ELEMENT_ROLE = 'checkbox'
export const INPUT_ELEMENT = 'input'
